import { PluginFunction } from 'vue';
import { formatDateLocal, formatDateMonthYear, formatDateMonth, formatDateMonthShort, formatDateYear } from '@/helpers/dates';

function getCurrentDate() {
	return new Date();
}

export const Dates: PluginFunction<any> = (Vue) => {
	Vue.filter('dateLocal', formatDateLocal);
	Vue.filter('dateMonth', formatDateMonth);
	Vue.filter('dateMonthShort', formatDateMonthShort);
	Vue.filter('dateMonthYear', formatDateMonthYear);
	Vue.filter('dateYear', formatDateYear);
	Vue.mixin({
		methods: {
			formatDateLocal,
			formatDateMonth,
			formatDateMonthShort,
			formatDateMonthYear,
			formatDateYear,
			getCurrentDate
		}
	});
}

declare module "vue/types/vue" {
	interface Vue {
		formatDateLocal: typeof formatDateLocal;
		formatDateMonth: typeof formatDateMonth;
		formatDateMonthShort: typeof formatDateMonthShort;
		formatDateMonthYear: typeof formatDateMonthYear;
		formatDateYear: typeof formatDateYear;
		getCurrentDate: typeof getCurrentDate;
	}
}
